import { render, staticRenderFns } from "./DeleteOnboardingLink.vue?vue&type=template&id=5924a86a&"
import script from "./DeleteOnboardingLink.vue?vue&type=script&lang=js&"
export * from "./DeleteOnboardingLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports